import BaseGenericRequest from "../BaseGenericRequest";
import TaskResponse from "../TaskResponse";
import User from "../../model/User";
import {METHOD} from "@cuatroochenta/co-generic-request";
import Urls from "../Urls";
import {generateRoute} from "../../utils/Router";

export default class TaskUserDetail extends BaseGenericRequest<{}, TaskResponse<User>> {

    public constructor(userId: string) {
        super(METHOD.GET, generateRoute(Urls.URL_USER_DETAIL, {uuid: userId}));
    }
}
